import { common } from "./common";
import { admin } from "./admin";
import { client } from "./client";
export const texts = { common, admin, client };
